import { render, staticRenderFns } from "./KeyAreasAndAbnormalPressure.vue?vue&type=template&id=1253a2ae&scoped=true"
import script from "./KeyAreasAndAbnormalPressure.vue?vue&type=script&lang=js"
export * from "./KeyAreasAndAbnormalPressure.vue?vue&type=script&lang=js"
import style0 from "./KeyAreasAndAbnormalPressure.vue?vue&type=style&index=0&id=1253a2ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1253a2ae",
  null
  
)

export default component.exports